import { useBrandContext, useBrandContextOptional } from "@/contexts/brand-context";

export interface Permissions {
  canApprove: boolean;
  canEdit: boolean;
  canSchedule: boolean;
  canManageBrand: boolean;
  canEditSchedulingConfig: boolean;
  canViewAiCosts: boolean;
  canEditBudget: boolean;
  canOverrideBudget: boolean;
  canViewAnalytics: boolean;
  canTriggerSync: boolean;
  role: string;
}

export function getPermissions(role: string, isOrgOwner = false): Permissions {
  return {
    canApprove: role === "ADMIN" || role === "REVIEWER",
    canEdit: role === "ADMIN" || role === "CREATOR",
    canSchedule: role === "ADMIN" || role === "SCHEDULER",
    canManageBrand: role === "ADMIN",
    canEditSchedulingConfig: role === "ADMIN",
    canViewAiCosts:
      role === "ADMIN" ||
      role === "CREATOR" ||
      role === "REVIEWER" ||
      role === "SCHEDULER",
    canEditBudget: role === "ADMIN",
    canOverrideBudget: isOrgOwner,
    canViewAnalytics:
      role === "ADMIN" ||
      role === "CREATOR" ||
      role === "REVIEWER" ||
      role === "SCHEDULER" ||
      role === "VIEWER",
    canTriggerSync: role === "ADMIN",
    role,
  };
}

export function usePermissions(): Permissions {
  const { currentUserRole, isOrgOwner } = useBrandContext();
  return getPermissions(currentUserRole, isOrgOwner ?? false);
}

/**
 * Non-throwing variant for components that may render outside a BrandProvider
 * (e.g. the global Sidebar). Returns null when no brand context is available.
 */
export function usePermissionsOptional(): Permissions | null {
  const ctx = useBrandContextOptional();
  if (!ctx) return null;
  return getPermissions(ctx.currentUserRole, ctx.isOrgOwner ?? false);
}
